import React from "react"; 
import { Link } from "react-router-dom";  
import EditBrandForm from "../../../components/Dashboard/BrandsListContent/Edit";

const EditBrand = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit Brand</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>eCommerce</li>
          <li>Edit Brand</li>
        </ul>
      </div> */}

      <EditBrandForm />
    </>
  );
};

export default EditBrand;
